import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e678b5fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "ModalEditarFiltro",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "ModalEditarFiltro",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Editar Filtro"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_6 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_7 = { class: "card d-flex flex-row mb-4" }
const _hoisted_8 = {
  class: "card w-100 justify-content-between pt-0 pb-0",
  id: "cardVeiculo"
}
const _hoisted_9 = {
  class: "card w-100 justify-content-between p-6",
  id: "cardProduto"
}
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger fs-6"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-12 col-xl-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Marca "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_15 = { class: "col-sm-12 col-xl-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Modelo "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_17 = { class: "col-sm-12 col-xl-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Tipo de Filtro "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_19 = { class: "col-sm-12 col-xl-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" EAN "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_21 = { class: "col-sm-12 col-xl-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Status "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Descrição", -1))
const _hoisted_25 = {
  class: "col-12",
  style: {"position":"relative"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Imagem", -1))
const _hoisted_27 = {
  class: "shadow-sm d-flex justify-content-center rounded",
  style: {"background-color":"#dedede"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_374_1959)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M23.194 21.9467H2.88147C1.58704 21.9467 0.53772 20.8973 0.53772 19.6029V5.54041C0.53772 4.24597 1.58704 3.19666 2.88147 3.19666H23.194C24.4884 3.19666 25.5377 4.24597 25.5377 5.54041V19.6029C25.5377 20.8973 24.4884 21.9467 23.194 21.9467ZM6.00647 5.93103C4.49631 5.93103 3.27209 7.15525 3.27209 8.66541C3.27209 10.1756 4.49631 11.3998 6.00647 11.3998C7.51663 11.3998 8.74084 10.1756 8.74084 8.66541C8.74084 7.15525 7.51663 5.93103 6.00647 5.93103ZM3.66272 18.8217H22.4127V13.3529L18.1395 9.07971C17.9107 8.8509 17.5397 8.8509 17.3109 9.07971L10.694 15.6967L7.98328 12.986C7.75447 12.7572 7.38347 12.7572 7.15461 12.986L3.66272 16.4779V18.8217Z",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_374_1959" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "25",
          height: "25",
          fill: "white",
          transform: "translate(0.53772 0.0716553)"
        })
      ])
    ])
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "imagem-edit-filtro",
  style: {"cursor":"pointer"}
}, "Enviar arquivo", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "nome-arquivo"
}
const _hoisted_32 = {
  class: "col-12 d-flex justify-content-end mt-4",
  id: "btn-group"
}
const _hoisted_33 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.spanWarning == true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Preencha todos os campos obrigatorios "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_el_select, {
                          placeholder: "Marca",
                          type: "text",
                          clearable: "",
                          filterable: "",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3","width":"100%"},
                          modelValue: _ctx.filtroUnico.id_marca,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtroUnico.id_marca) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcasDeFiltros, (marcaProd, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: key,
                                label: marcaProd.nome,
                                value: marcaProd.id_marca_produto
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_el_input, {
                          placeholder: "Modelo",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.filtroUnico.filtro,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtroUnico.filtro) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_el_select, {
                          placeholder: "Tipo de Filtro",
                          type: "text",
                          clearable: "",
                          filterable: "",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3","width":"100%"},
                          modelValue: _ctx.filtroUnico.id_tipo,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtroUnico.id_tipo) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiposDeFiltro, (tipoFiltro, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: key,
                                label: tipoFiltro.descricao,
                                value: tipoFiltro.id_tipo_produto
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_el_input, {
                          placeholder: "Código EAN",
                          onInput: _cache[3] || (_cache[3] = (val) => _ctx.validateOnlyNumbers(val, 'ean')),
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.filtroUnico.ean,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtroUnico.ean) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_el_select, {
                          placeholder: "Status",
                          type: "text",
                          clearable: "",
                          filterable: "",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3","width":"100%"},
                          modelValue: _ctx.filtroUnico.status,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtroUnico.status) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (statusOpt, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: key,
                                label: statusOpt,
                                value: statusOpt
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_el_input, {
                          placeholder: "Descrição do produto",
                          type: "textarea",
                          rows: 6,
                          autosize: { minRows: 6, maxRows: 6 },
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.filtroUnico.descricao,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filtroUnico.descricao) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_el_image, {
                            src: _ctx.filtroUnico.imagemPreview || _ctx.filtroUnico.imagem,
                            fit: "contain",
                            style: {"display":"flex","justify-content":"center","align-items":"center","height":"138px"}
                          }, {
                            error: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 1
                          }, 8, ["src"])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light-danger send-file",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openFileDialog && _ctx.openFileDialog(...args)))
                        }, _hoisted_30),
                        _createElementVNode("input", {
                          type: "file",
                          ref: "imagem-edit-filtro",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleImgFileChange($event))),
                          name: "imagem",
                          id: "imagem-edit-filtro",
                          class: "select-file"
                        }, null, 544)
                      ]),
                      (_ctx.fileName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.fileName), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Button, {
                          type: "submit",
                          variant: "primary",
                          text: "Salvar",
                          onClick: _ctx.onSave
                        }, {
                          default: _withCtx(() => [
                            (_ctx.loadSalvar)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_36, _hoisted_38))
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}